import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const Article = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "article-page" */ './hocs')),
});
